import { render, staticRenderFns } from "./cpt-chart-clock.vue?vue&type=template&id=5ffbdaed&scoped=true&"
import script from "./cpt-chart-clock.vue?vue&type=script&lang=js&"
export * from "./cpt-chart-clock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffbdaed",
  null
  
)

export default component.exports